<template>
    <div>
        <top_box :return_="true" @backf='backf()'></top_box>
        <div class="topkongbox"></div>
		<div class="mainbox">
			<!-- user 左侧 -->
			<div class="left_box">
				<div class="jiantouicon pointer jiantouicon_a" style="margin-bottom: 10rpx;"  @mouseover="openee()" @mouseout="openee()" >
					<img src="../../static/images/jiantouyou.png" alt="">
				</div>
				<div v-if="is_small" @click="backf()" class="Navigation_bg"></div>
				<div :class="is_small?'Navigation Navigation-a':'Navigation'">
					<!-- 个人信息模块 -->
					<div class="user_img">
						<el-image class="pointer" :style="right_is_opem?'width: 100px; height: 100px':'width: 80px; height: 80px'" :src="user_data.head_pic"
							:preview-src-list="[user_data.head_pic]">
						</el-image>
					</div>
					<div class="user_name">
						{{ user_data.nickname }}
					</div>
					<div class="user_mailbox">
						{{ user_data.email }}
					</div>
					
					<div class="nav_list">
						<div :class="{ nav_item1: item.Selected }" class="nav_item pointer"
							v-for="(item, index) in nav_list" :key="index" @click="chang_nav(index)">
							<span v-if="right_is_opem">{{ item.text }}</span>
							<block v-else>
								<block v-if="index==0">
									<img v-if="item.Selected" src="../../static/usericonH/icon1.png" alt="">
									<img v-else src="../../static/usericon/icon1.png" alt="">
								</block>
								<block v-if="index==1">
									<img v-if="item.Selected" src="../../static/usericonH/icon2.png" alt="">
									<img v-else src="../../static/usericon/icon2.png" alt="">
								</block>
								<block v-if="index==2">
									<img v-if="item.Selected" src="../../static/usericonH/icon3.png" alt="">
									<img v-else src="../../static/usericon/icon3.png" alt="">
								</block>
								<block v-if="index==3">
									<img v-if="item.Selected" src="../../static/usericonH/icon4.png" alt="">
									<img v-else src="../../static/usericon/icon4.png" alt="">
								</block>
								<block v-if="index==4">
									<img v-if="item.Selected" src="../../static/usericonH/icon5.png" alt="">
									<img v-else src="../../static/usericon/icon5.png" alt="">
								</block>
								<block v-if="index==5">
									<img v-if="item.Selected" src="../../static/usericonH/icon6.png" alt="">
									<img v-else src="../../static/usericon/icon6.png" alt="">
								</block>
								<block v-if="index==6">
									<img v-if="item.Selected" src="../../static/usericonH/icon7.png" alt="">
									<img v-else src="../../static/usericon/icon7.png" alt="">
								</block>
								<block v-if="index==7">
									<img v-if="item.Selected" src="../../static/usericonH/icon8.png" alt="">
									<img v-else src="../../static/usericon/icon8.png" alt="">
								</block>
								<block v-if="index==8">
									<img v-if="item.Selected" src="../../static/usericonH/icon9.png" alt="">
									<img v-else src="../../static/usericon/icon9.png" alt="">
								</block>
							</block>
						</div>
					</div>
					
				</div>
			</div>
			<!-- 右侧 -->
            <div class="infobox">
                <router-view></router-view>
            </div>
        </div>
        <div class="showbox3">
            <el-dialog :visible.sync="Receiving_show" width="350px" :show-close="false" center>
                <div class=" showbox2">
                    <!-- <div class="bar">—</div> -->
                    <div class="title">{{$t('m.address_12')}}</div>
                    <p>{{$t('m.index_10')}}</p>
                    <div class="btnboxli">
                        <div class="btnbox1 pointer" @click="Receiving_show = false">
                            <span>{{$t('m.address_08')}}</span>
                        </div>
                        <div class="btnbox pointer" @click="confirm()">
                            <span>{{$t('m.index_11')}}</span>
                        </div>
                    </div>
                </div>
            </el-dialog>
        </div>
		
		
		<!-- 公共底部 -->
		<fot_box></fot_box>
    </div>
</template>
<script>
import top_box from '../../components/header_top'
import fot_box from '../../components/foot'
export default {
    components:{top_box,fot_box},
    data() {
        return {
			is_small:true,
			right_is_opem:true,
            Receiving_show: false,
            user_data: {},
            nav_list: [
                {
                    text: this.$t('m.index_01'),
                    path: '/user/userhome',
                    Selected: true,
					img:'../../static/usericon/home-fill.png',
					img_h:'../../static/usericonH/home-fill.png',
                },
                {
                    text: this.$t('m.index_02'),
                    path: '/user/userinfo',
                    Selected: false,
					img:'../../static/usericon/yonghu.png',
					img_h:'../../static/usericonH/yonghu.png',
                },
                {
                    text: this.$t('m.index_03'),
                    path: '/user/MallCenter',
                    Selected: false,
					img:'../../static/usericon/shangcheng.png',
					img_h:'../../static/usericonH/shangcheng.png',
                },
                {
                    text: this.$t('m.index_04'),
                    path: '/user/Myorder',
                    Selected: false,
					img:'../../static/usericon/dingdan-quanbudingdan.png',
					img_h:'../../static/usericonH/dingdan-quanbudingdan.png',
                },
                {
                    text: this.$t('m.index_05'),
                    path: '/user/address',
                    Selected: false,
					img:'../../static/usericon/daohangdizhi.png',
					img_h:'../../static/usericonH/daohangdizhi.png.png',
                },
                {
                    text: this.$t('m.index_06'),
                    path: '/user/RetrievePWD',
                    Selected: false,
					img:'../../static/usericon/tianchongxing-.png',
					img_h:'../../static/usericonH/tianchongxing-.png',
                },
                {
                    text: this.$t('m.index_07'),
                    path: '/user/Mymessage',
                    Selected: false,
					img:'../../static/usericon/daohangdizhi.png',
					img_h:'../../static/usericonH/daohangdizhi.png',
                },
                {
                    text: this.$t('m.index_08'),
                    path: '/user/HelpCenter',
                    Selected: false,
					img:'../../static/usericon/xiaoxi.png',
					img_h:'../../static/usericonH/xiaoxi.png',
                },
                {
                    text: this.$t('m.index_09'),
                    path: '',
                    Selected: false,
					img:'../../static/usericon/home-fill.png',
					img_h:'../../static/usericonH/home-fill.png',
                }
            ]

        }
    },
    created() {
        this.getuserdata()
        this.nav_list.forEach(item => {
            item.Selected = false
            if (item.path == this.$route.path) {
                item.Selected = true
            }
        })
		// 判断显示屏宽
		var is_h5 = document.documentElement.clientWidth || document.body.clientHeight;
		if(is_h5<1200){
			this.is_small = false
		}
    },
    methods: {
		backf(){
			this.is_small = !this.is_small 
		},
        getuserdata() {
            let user_data = JSON.parse(localStorage.getItem('user_data'))
            this.user_data = user_data
        },
        confirm() {
            localStorage.removeItem("user_data");
            this.$router.push({
                path: '/account/login'
            })
        },
		openee(){
			this.is_small = true
		},
        chang_nav(index) {
			if(index==2){
				// console.log(1)
				this.is_small = false
			}
			
			var is_h5 = document.documentElement.clientWidth || document.body.clientHeight;
			if(is_h5<1200){
				this.is_small = false
			}
			
            if (this.nav_list[index].path == '') {
                this.Receiving_show = true
            } else {
                this.nav_list.forEach(item => {
                    item.Selected = false
                });
                this.nav_list[index].Selected = true
                this.$router.push({
                    path: this.nav_list[index].path
                })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.jiantouicon {
	width: 60px;
	height: 60px;
	border-radius: 50%;
	border: 2px solid #555;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 17px;
	img {
		width: 19px;
		// height: 7px;
	}
}
.jiantouicon_a{
	border: 1px solid #ef5843;
	background-color: #ef5843;
}

	
	
.topkongbox {
    width: 100%;
    height: 45px;
}
.mainbox {
    padding: 0 128px;
    margin: 0 auto;
    display: flex;
	padding-bottom: 60px;
	min-height: 978px;
    .infobox {
        margin-left: 1%;
        width: 95.3%;
        background-color: #fff;
        padding: 35px 80px 100px 80px;
        // min-width: 800px;
    }
	.Navigation-a{
		height: 840px!important;
		padding: 30px 0px!important;
		transition: 0.3s!important;
	}
    .Navigation{
		position: absolute;
        width: 220px;
        height: 0px;
		overflow: hidden;
        background-color: #fff;
        padding: 0px 0px;
		z-index: 2;
		left: 50%;
		border-radius: 4px;
		transform: translateX(-50%);
		transition: 0.3s;
		box-shadow: 0 1px 6px #ddd;
        .user_img {
            text-align: center;
            ::v-deep .el-image__preview {
                border-radius: 50% !important;
            }
            img {
                width: 100px;
                height: 100px;
                border-radius: 50%;
            }
        }
        .user_name {
            margin-top: 10px;
            text-align: center;
            font-weight: bold;
            font-size: 20px;
            padding: 0 20px;
            overflow: hidden;
            text-overflow: ellipsis;
			font-size: 28px;
            -webkit-line-clamp: 1; // 控制多行的行数
            -webkit-box-orient: vertical;
        }

        .user_mailbox {
            text-align: center;
            margin-top: 10px;
            font-size: 15px;
        }

        .nav_list {
            width: 100%;
            margin-top: 38px;
			img{
				width: 30px;
			}
            .nav_item {
                font-size: 18px;
                font-weight: bold;
                background-color: #fff;
                text-align: center;
                height: 62px;
                // line-height: 62px;
				display: flex;
				align-items: center;
				justify-content: center;
            }

            .nav_item1 {
                background-color: #ef5843;

                color: #fff;
            }
        }

    }
}

.showbox2 {
    padding: 30px;
    background-color: #fff;
    border-radius: 4px;

    .bar {
        font-weight: bold;
        text-align: center;
    }

    .title {
        font-size: 24px;
        font-weight: bold;
        text-align: center;
        margin-top: 0 !important;

    }

    p {
        margin-top: 10px;
        text-align: center;
    }

    .btnboxli {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 40px;
        .btnbox {
            background-color: #ef5843;
            height: 54px;
            width: 120px;
            display: flex;
            align-items: center;
            color: #fff;
            border-radius: 4px;
            justify-content: center;
            margin-left: 20px;
            span {
                font-weight: bold;
            }
        }

        .btnbox1 {
            background-color: #fff;
            color: #ef5843;
            border: 3px solid #ef5843;
            border-radius: 4px;
            height: 54px;
            width: 120px;

            span {
                font-weight: bold;
            }

            display: flex;
            align-items: center;
            justify-content: center;


        }
    }
}
.left_box{
	position: relative;height: 77px;
}

.showbox3 {
    ::v-deep .el-dialog__header {
        padding: 0 !important;
    }

    ::v-deep .el-dialog__body {
        padding: 0 !important;
    }

    ::v-deep .el-dialog {
        margin-top: 35vh !important;
        border-radius: 4px;
        border-top: 5px solid #ef5843;
    }
}
.Navigation_bg{display: none;}


// 宽度小于1200px
@media screen and (max-width: 1200px){
	.topkongbox{display: none!important;}
	.mainbox{
		padding: 0;
		display: block;
		.left_box{
			height: auto;
			.jiantouicon{
				display: none;
			}
			.Navigation_bg{
				display: block;
				width: 100%;position: fixed;
				height: 100%;
				top: 0;
				left: 0;
				background: rgba(0, 0, 0, 0.6);
				z-index: 3;
			}
			.Navigation{
				.user_img{
					display: none;
				}
				.user_name{
					display: none;
				}
				.user_mailbox{
					display: none;
				}
				position: fixed;
				padding-top: 3rem!important;
				width: 70%;
				height: 100%!important;
				overflow: scroll;
				top: 0;
				right: 0;
				left: 0;
				transform: translateX(-100%);
				z-index: 4;
				transition: 0.3s;
			}
			.Navigation-a{
				transform: translateX(0%);
			}
		}
		.infobox{
			width: 100%;
			margin-left: 0;
			padding: 0.6rem;
		}
	}
}
</style>